import { connect } from "react-redux";

import ConfirmationModal from "../../../views/Inventory/Items/ConfirmationModal/ConfirmationModal";
import {
  systemConstants,
  DEFAULT_CONFIRMATION_MODAL_REDUX,
} from "../../../constants";
import { custom } from "../../../redux/actions/actionsUtilities";

const ConfirmationModalRedux = ({
  isShow,
  message,
  formRef,
  handleYesButtonClick,
  confirmationModalRedux,
  setConfirmationModalRedux,
  ...props
}) => {
  return (
    <>
      {isShow && (
        <ConfirmationModal
          isConfirmationModal={isShow}
          handleNoButtonClick={() => {
            setConfirmationModalRedux(DEFAULT_CONFIRMATION_MODAL_REDUX);
          }}
          handleYesButtonClick={() => {
            handleYesButtonClick.functionToCall(
              ...handleYesButtonClick.functionAttributes
            );
            // false means Modal will be set to false after a successful response of api call (i.e delete user confirmation case)
            if (handleYesButtonClick.isResetModalOnYesButtonClick) {
              setConfirmationModalRedux(DEFAULT_CONFIRMATION_MODAL_REDUX);
            }
          }}
          message={message}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  isShow: state.system.confirmationModalRedux.isShow,
  message: state.system.confirmationModalRedux.message,
  confirmationModalRedux: state.system.confirmationModalRedux,
  handleYesButtonClick:
    state.system.confirmationModalRedux.handleYesButtonClick,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setConfirmationModalRedux: (data) =>
    dispatch(custom(data, systemConstants.SET_CONFIRMATION_MODAL_REDUX)),
});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationModalRedux);
